import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Col,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Upload
} from 'antd'
import { compressFile, getBase64 } from '../../../../utils/services'
import axios from 'axios'
import _, { isNull } from 'lodash'
import { useDeepEffect } from '../../../../utils/hooks'
import { ACTION } from '../../../../utils/constants'

const BrandCoverForm = (props) => {
  const { visible, brandId, onCancel, form, action, formState, onOk } = props
  const { getFieldDecorator, validateFields } = form

  const [imageUrl, setImageUrl] = useState('')

  useDeepEffect(() => {
    if (!isNull(formState)) {
      form.setFieldsValue({
        status: formState.status,
        title: formState.title,
        url: formState.url
      })
      setImageUrl(formState.image)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
    }
  }, [formState])

  async function uploadBrandCoverImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const token = localStorage.getItem('user-token')
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/brand-news/image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: !_.isNull(token) ? token : ''
          }
        }
      )

      return res.data
    } catch (err) {
      return null
    }
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        let img = null
        const data = {
          status: values.status,
          title: values.title,
          url: values.url,
          image: '',
          brandId: brandId
        }

        if (values.image) {
          img = await uploadBrandCoverImage(values.image.file)
          data.image = img.url
        } else {
          if (!isNull(formState)) {
            data.image = formState.image
          }
        }

        if (action === ACTION.UPDATE) {
          data.brandCoverId = formState.id
        }
        await onOk(data)
        await form.resetFields()
        await setImageUrl('')
      }
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
    }
    return false
  }

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  return (
    <Modal
      width={1000}
      title={`${action} a brand cover`}
      visible={visible}
      closable={false}
      footer={null}>
      <Form name="formBrandCover" onSubmit={onSubmit} layout="vertical">
        <Form.Item label="หัวข้อ">
          {getFieldDecorator(`title`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="URL News">
          {getFieldDecorator(`url`)(<Input />)}
        </Form.Item>
        <Form.Item label="Banner">
          {getFieldDecorator(`image`)(
            <Upload
              name="avatar"
              listType="picture-card"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}>
              {imageUrl ? (
                <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
              ) : (
                uploadButton
              )}
            </Upload>
          )}
        </Form.Item>
        <Form.Item label="Status">
          {getFieldDecorator(`status`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group>
              <Radio value={true}>Enabled</Radio>
              <Radio value={false}>Disabled</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Row type="flex" justify="end" gutter={8}>
          <Col>
            <Button onClick={() => onCancel()} key="cancel" type="danger">
              ยกเลิก
            </Button>
          </Col>
          <Col>
            <Button
              name="formBrandCover"
              key="submit"
              type="primary"
              htmlType="submit">
              บันทึก
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

BrandCoverForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  action: PropTypes.string.isRequired,
  formState: PropTypes.any.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedBrandCoverForm = Form.create({ name: 'BrandCoverForm' })(
  BrandCoverForm
)
export default WrappedBrandCoverForm
